export enum CountryEnum {
  US = 'US',
  CA = 'CA',
  GB = 'GB',
}

export enum FieldsEnum {
  firstName = 'firstName',
  lastName = 'lastName',
  password = 'password',
}
